export { default } from './EducationSelector';
export type { EducationType } from './EducationSelector';
